import { render, staticRenderFns } from "./IsReachableByPublicTransportsBox.vue?vue&type=template&id=45504eee&scoped=true"
import script from "./IsReachableByPublicTransportsBox.vue?vue&type=script&lang=js"
export * from "./IsReachableByPublicTransportsBox.vue?vue&type=script&lang=js"
import style0 from "./IsReachableByPublicTransportsBox.vue?vue&type=style&index=0&id=45504eee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45504eee",
  null
  
)

export default component.exports